import type { DashboardField } from "../types/contract";

// Pair each export with the dashboard field it names. An export whose field is
// not in the selection is dropped, because there is nothing to send it for.
export function jdSendRows<E extends { fieldId: string }>(
  fields: readonly DashboardField[],
  exports: readonly E[],
): { export: E; field: DashboardField }[] {
  const byId = new Map(fields.map((field) => [field.field_id, field]));
  return exports.flatMap((item) => {
    const field = byId.get(item.fieldId);
    return field ? [{ export: item, field }] : [];
  });
}
